import React from 'react';

export const DSAIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 5L35 30H5L20 5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="20" cy="20" r="3" fill="currentColor"/>
    <path d="M12 25H28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const MathIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="15" stroke="currentColor" strokeWidth="2"/>
    <path d="M13 20H27" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 13V27" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ElectronicsIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 8V32" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 20H32" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="20" cy="20" r="4" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 12L28 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const MechanicalIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 10C25.5228 10 30 14.4772 30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M20 15V20L23 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M27 13L29 11M11 29L13 27M29 29L27 27M13 13L11 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ChemicalIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 8H25V15L30 25V30H10V25L15 15V8Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M15 8H25" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 25L28 25" stroke="currentColor" strokeWidth="2"/>
    <path d="M20 15V20" stroke="currentColor" strokeWidth="2" strokeDasharray="2 2"/>
  </svg>
);

export const CivilIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 32H32" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 32V20H28V32" stroke="currentColor" strokeWidth="2"/>
    <path d="M20 8L30 20H10L20 8Z" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const NetworkIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="10" cy="10" r="2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="30" cy="10" r="2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="30" cy="30" r="2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="10" cy="30" r="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 12L18 18M22 22L28 28M28 12L22 18M12 28L18 22" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const EmbeddedIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="10" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M15 20H25" stroke="currentColor" strokeWidth="2"/>
    <path d="M20 15V25" stroke="currentColor" strokeWidth="2"/>
    <circle cx="15" cy="15" r="1" fill="currentColor"/>
    <circle cx="25" cy="25" r="1" fill="currentColor"/>
  </svg>
);

export const ScienceIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 8C15 6.89543 15.8954 6 17 6H23C24.1046 6 25 6.89543 25 8V15L30 25V32C30 33.1046 29.1046 34 28 34H12C10.8954 34 10 33.1046 10 32V25L15 15V8Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M15 20L25 20" stroke="currentColor" strokeWidth="2" strokeDasharray="2 2"/>
    <path d="M20 8V13" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

export const LanguageIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="14" stroke="currentColor" strokeWidth="2"/>
    <path d="M10 20H30" stroke="currentColor" strokeWidth="2"/>
    <path d="M20 10C22.7614 13.3333 24.1429 16.6667 24.1429 20C24.1429 23.3333 22.7614 26.6667 20 30" stroke="currentColor" strokeWidth="2"/>
    <path d="M20 10C17.2386 13.3333 15.8571 16.6667 15.8571 20C15.8571 23.3333 17.2386 26.6667 20 30" stroke="currentColor" strokeWidth="2"/>
  </svg>
);
